// Single source of truth for storefront brand data.
// Swap the DBA name / contacts here and the whole storefront follows.
export const BRAND = {
  name: "Biscayne Quilt Supply",
  shortName: "Biscayne",
  tagline: "Quilting & sewing supplies, made for makers",
  legalName: "AKLDGROUP LLC",
  addressLines: ["2125 Biscayne Blvd, Ste 204 #24519", "Miami, FL 33137, USA"],
  email: "hello@biscaynequiltsupply.com",
  wholesaleEmail: "wholesale@biscaynequiltsupply.com",
  phone: "+1 (929) 377-2441",
  phoneHref: "tel:+19293772441",
  hours: "Mon–Fri · 9am–5pm ET",
  freeShippingThreshold: 75,
  instagram: "https://www.instagram.com/biscaynequilt/",
  pinterest: "https://pin.it/3FIeFdJyg",
};

export const LEGAL_LINE = `${BRAND.name} is operated by ${BRAND.legalName}, ${BRAND.addressLines[0]}, ${BRAND.addressLines[1].replace(", USA", "")}.`;
